import { render, staticRenderFns } from "./sk-img-wap.vue?vue&type=template&id=43fafca9&scoped=true&"
import script from "./sk-img-wap.vue?vue&type=script&lang=js&"
export * from "./sk-img-wap.vue?vue&type=script&lang=js&"
import style0 from "./sk-img-wap.vue?vue&type=style&index=0&id=43fafca9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fafca9",
  null
  
)

export default component.exports